// Mock data for Anyone Music Records website

export const artists = [
  {
    id: 1,
    name: "MARCUS VEIL",
    genre: "Deep House",
    image: "https://images.unsplash.com/photo-1599839575729-0009ea68e319?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxESiUyMGhlYWRzaG90fGVufDB8fHx8MTc3MTU1NTQ3NXww&ixlib=rb-4.1.0&q=85",
    bio: "Toronto-based producer crafting emotive deep house journeys",
    socialLinks: {
      instagram: "https://instagram.com/marcusveil",
      spotify: "https://open.spotify.com/artist/marcusveil",
      soundcloud: "https://soundcloud.com/marcusveil"
    }
  },
  {
    id: 2,
    name: "LUNA RHODES",
    genre: "Progressive House",
    image: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzE1MDY0Nzd8MA&ixlib=rb-4.1.0&q=85",
    bio: "Crafting ethereal soundscapes from Tulum studios",
    socialLinks: {
      instagram: "https://instagram.com/lunarhodes",
      spotify: "https://open.spotify.com/artist/lunarhodes",
      soundcloud: "https://soundcloud.com/lunarhodes"
    }
  },
  {
    id: 3,
    name: "ALEX NOIR",
    genre: "Techno",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzE1MDY0Nzd8MA&ixlib=rb-4.1.0&q=85",
    bio: "Dark, driving techno from the underground",
    socialLinks: {
      instagram: "https://instagram.com/alexnoir",
      spotify: "https://open.spotify.com/artist/alexnoir",
      soundcloud: "https://soundcloud.com/alexnoir"
    }
  },
  {
    id: 4,
    name: "SAGE MERIDIAN",
    genre: "Organic House",
    image: "https://images.pexels.com/photos/30535621/pexels-photo-30535621.jpeg",
    bio: "Blending organic textures with electronic precision",
    socialLinks: {
      instagram: "https://instagram.com/sagemeridian",
      spotify: "https://open.spotify.com/artist/sagemeridian",
      soundcloud: "https://soundcloud.com/sagemeridian"
    }
  }
];

export const events = [
  {
    id: 1,
    title: "ANYONE PRESENTS: WAREHOUSE",
    location: "Toronto, Canada",
    city: "Toronto",
    date: "2025-01-15",
    displayDate: "JAN 15",
    venue: "The Junction Warehouse",
    time: "22:00",
    image: "https://images.unsplash.com/photo-1624929303661-22c5bce0169b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxlbGVjdHJvbmljJTIwbXVzaWMlMjBmZXN0aXZhbCUyMGNyb3dkJTIwbGlnaHRzfGVufDB8fHx8MTc3MTU1NTUxMXww&ixlib=rb-4.1.0&q=85",
    lineup: ["Marcus Veil", "Alex Noir", "Luna Rhodes"],
    ticketLink: "#"
  },
  {
    id: 2,
    title: "TULUM BEACH SESSIONS",
    location: "Tulum, Mexico",
    city: "Tulum",
    date: "2025-02-20",
    displayDate: "FEB 20",
    venue: "Papaya Playa Project",
    time: "18:00",
    image: "https://images.pexels.com/photos/426976/pexels-photo-426976.jpeg",
    lineup: ["Luna Rhodes", "Sage Meridian"],
    ticketLink: "#"
  },
  {
    id: 3,
    title: "IBIZA SUNSET RITUAL",
    location: "Ibiza, Spain",
    city: "Ibiza",
    date: "2025-03-10",
    displayDate: "MAR 10",
    venue: "Sunset Ashram",
    time: "19:00",
    image: "https://images.pexels.com/photos/1190298/pexels-photo-1190298.jpeg",
    lineup: ["Marcus Veil", "Luna Rhodes", "Alex Noir", "Sage Meridian"],
    ticketLink: "#"
  }
];

export const releases = [
  {
    id: 1,
    title: "Agape",
    artist: "Blanchecho",
    artwork: "https://imagestore.ffm.to/link/696df8402c00002d007b573b/696df8483200001300990604_db156738889ea03bb3a2abdf12c6326c.jpeg",
    releaseDate: "2024-11",
    streamLink: "https://ditto.fm/agape_84f3aa89",
    genre: "Deep House"
  },
  {
    id: 2,
    title: "End of Time",
    artist: "Blanchecho",
    artwork: "https://imagestore.ffm.to/link/696df8402c00002d007b573b/69870b713400001500c9d118_439ae903909f5f693d0a1d5a31a4b0f8.jpeg",
    releaseDate: "2024-10",
    streamLink: "https://ditto.fm/end_of_time_3344db63",
    genre: "Progressive House"
  },
  {
    id: 3,
    title: "Hope",
    artist: "Blanchecho",
    artwork: "https://imagestore.ffm.to/link/696df8402c00002d007b573b/69870b7f3f00002e00d55e31_6d3fa5ea3c97acd22bbc27cc0db81701.jpeg",
    releaseDate: "2024-09",
    streamLink: "https://ditto.fm/hope_63ebadcf",
    genre: "Techno"
  },
  {
    id: 4,
    title: "Chase This",
    artist: "Blanchecho",
    artwork: "https://imagestore.ffm.to/link/696df8402c00002d007b573b/69870b843200004600769702_dfdc7003db37f24e3da74ae3ca48f722.jpeg",
    releaseDate: "2024-08",
    streamLink: "https://ditto.fm/chase-this",
    genre: "Organic House"
  },
  {
    id: 5,
    title: "Hot Like Me",
    artist: "Blanchecho",
    artwork: "https://imagestore.ffm.to/link/696df8402c00002d007b573b/6982b8733c0000a500ef9e7e_c149ef6f084511aeae21d54214aa2e71.webp",
    releaseDate: "2024-07",
    streamLink: "https://ditto.fm/hot_like_me",
    genre: "Deep House"
  },
  {
    id: 6,
    title: "One More Time",
    artist: "Blanchecho",
    artwork: "https://imagestore.ffm.to/link/696df8402c00002d007b573b/698ecaad2e00003a00d665b4_45cfb05458e758a60a1ebafd8c93372f.jpeg",
    releaseDate: "2024-06",
    streamLink: "https://ditto.fm/one_more_time_a7ca2e87",
    genre: "Progressive House"
  }
];

export const additionalReleases = [];

export const benefits = [
  {
    id: 1,
    title: "Professional Distribution",
    description: "Get heard on Spotify, Apple Music, Beatport, and beyond with our global distribution network",
    icon: "Globe"
  },
  {
    id: 2,
    title: "Creative Freedom",
    description: "We respect your vision. We're here to amplify it, not change it",
    icon: "Sparkles"
  },
  {
    id: 3,
    title: "Marketing Power",
    description: "Targeted campaigns to get your music in front of the listeners who matter",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Event Network",
    description: "Opportunities to showcase your sound where it belongs—on the big stage",
    icon: "Calendar"
  },
  {
    id: 5,
    title: "Career Development",
    description: "We build careers, not just sign tracks. Long-term artist development and support",
    icon: "Users"
  },
  {
    id: 6,
    title: "Industry Connections",
    description: "Access to our network of promoters, DJs, and industry professionals worldwide",
    icon: "Network"
  }
];

export const testimonials = [
  {
    id: 1,
    artist: "Marcus Veil",
    quote: "Anyone Music Records gave me the platform to reach a global audience. The support has been incredible.",
    image: "https://images.unsplash.com/photo-1599839575729-0009ea68e319?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxESiUyMGhlYWRzaG90fGVufDB8fHx8MTc3MTU1NTQ3NXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    artist: "Luna Rhodes",
    quote: "The creative freedom combined with professional support is unmatched. Proud to be part of the AMR family.",
    image: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzE1MDY0Nzd8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    artist: "Alex Noir",
    quote: "From demo submission to international release in just weeks. AMR moves fast and delivers results.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzE1MDY0Nzd8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const cities = [
  { name: "Toronto", lat: 43.65, lng: -79.38 },
  { name: "Tulum", lat: 20.21, lng: -87.43 },
  { name: "Ibiza", lat: 38.91, lng: 1.43 }
];

export const labelPhilosophy = {
  title: "We Don't Follow The Beat. We Build It.",
  content: "Anyone Music Records was born from a simple, radical belief: Music shouldn't have gatekeepers. We are a high-energy electronic music label dedicated to discovering the raw, the real, and the revolutionary. We believe that inside everyone is a rhythm waiting to be unleashed. Whether you're producing in a bedroom in Tokyo, a basement in Berlin, or a studio in Toronto—if you have the passion, we provide the platform. We are here to amplify the inner drive that makes electronic music the universal language of the world.",
  mission: "To discover and empower artists from every corner of the globe, giving them the stage, the tools, and the volume to share their vision with the world.",
  values: [
    "Passion First: Technique can be taught. Passion is the spark we look for.",
    "Limitless Vision: We embrace creativity that breaks boundaries.",
    "Inclusive Energy: The stage belongs to Anyone.",
    "Global Connection: One beat, one world."
  ]
};

export const demoGuidelines = {
  acceptedGenres: ["Deep House", "Techno", "Progressive House", "Organic House"],
  formats: ["MP3 (320kbps)", "WAV (16-bit or 24-bit)"],
  responseTime: "4-6 weeks",
  requirements: [
    "Original, unreleased music only",
    "Include artist bio and social media links",
    "Limit: 3 tracks maximum per submission",
    "Professional quality production and mixdown"
  ]
};
